// Proyecto en blanco con una placa. Lo usan el editor («Proyecto nuevo») y el portal (plantilla en blanco de
// una tarea); solo necesita las definiciones de piezas, no la escena ni el simulador.
import { getDef } from './parts/index.js';

export const BLANK_CODE = `void setup() {
  // Se ejecuta una vez al encender o reiniciar el Arduino.
  Serial.begin(9600);
}

void loop() {
  // Se repite sin parar.
}
`;

/** Prefijo de los identificadores de pieza («uno», «led1», «r2»…). */
export const PREFIX = {
  'arduino-uno': 'uno', 'arduino-nano': 'nano', 'arduino-mega': 'mega', 'arduino-pro-mini': 'mini', attiny85: 'tiny', 'usb-serial': 'ftdi',
  'pi-pico': 'pico', breadboard: 'bb', resistor: 'r', led: 'led', 'rgb-led': 'rgb',
  pushbutton: 'btn', potentiometer: 'pot', 'slide-potentiometer': 'slider', 'slide-switch': 'sw', buzzer: 'buzzer',
};

export function blankProject(board = 'arduino-uno', name = 'Proyecto sin título') {
  // Cada placa puede traer su plantilla (p. ej. la Pico: Serial es el USB).
  const code = getDef(board).template || BLANK_CODE;
  return { name, files: { 'sketch.ino': code }, parts: [{ id: PREFIX[board] || 'uno', type: board, x: 0, z: 0, rot: 0, props: {} }], wires: [] };
}
